"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _system = require("@mui/system");
var _MemberCard = _interopRequireDefault(require("./Cards/MemberCard"));
var _concatTokens = _interopRequireDefault(require("../services/concatTokens"));
var _Button = _interopRequireDefault(require("./Button"));
var _Text = _interopRequireDefault(require("./Text"));
var _theme = require("../theme");
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _tokens = _interopRequireDefault(require("../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MemberListHeader = (0, _system.styled)(_Grid["default"])({
  backgroundColor: _theme.colors.surface,
  borderLeft: "".concat(_theme.colors.surface, " solid 5px"),
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  cursor: 'pointer',
  height: 'auto',
  marginBottom: '0',
  minHeight: '70px',
  padding: '10px',
  position: 'relative',
  zIndex: 4,
  borderBottom: '2px solid rgba(0, 0, 0, 0.09)'
});
var MemberList = /*#__PURE__*/function (_Component) {
  function MemberList() {
    var _this;
    (0, _classCallCheck2["default"])(this, MemberList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, MemberList, [].concat(args)), _this.state = {
      employeeList: _this.props.employees,
      memberCards: [],
      loadIndex: 50
    }, _this._loadMore = function () {
      var newBatch = _this.state.employeeList.slice(_this.state.loadIndex, _this.state.loadIndex + 50);
      var newComponents = newBatch.map(function (member) {
        return /*#__PURE__*/_react["default"].createElement(_MemberCard["default"], {
          key: (0, _concatTokens["default"])(member.classID, member.userID),
          member: member,
          division: _this.props.divisions[member.divisionID],
          "class": _this.props.classesData[member.classID],
          sendNotification: function sendNotification() {
            return _this.props.toggleNotificationModal(member.userID);
          },
          onEditEmployee: function onEditEmployee() {
            return _this.props.editEmployee(member);
          },
          onManageEmployee: function onManageEmployee() {
            return _this.props.manageEmployee(member);
          },
          onClick: function onClick() {
            window.location.href = _this.props.isMasterSite ? "/members/".concat(member.userID) : "/employee/".concat(member.accountID, "/").concat(member.userID);
          }
        });
      });
      _this.setState({
        loadIndex: _this.state.loadIndex + 50,
        memberCards: _this.state.memberCards.concat(newComponents)
      });
    }, _this._handleMenuClick = function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    }, _this._handleCloseMenu = function () {
      _this.setState({
        anchorEl: null
      });
    }, _this._editUser = function () {
      _this._handleCloseMenu();
      _this.props.onEditEmployee();
    }, _this._notifyUser = function () {
      _this._handleCloseMenu();
      _this.props.sendNotification();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(MemberList, _Component);
  return (0, _createClass2["default"])(MemberList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var firstMemberLoad = this.props.employees.slice(0, 50);
      var firstMemberCards = firstMemberLoad.map(function (member, i) {
        return /*#__PURE__*/_react["default"].createElement(_MemberCard["default"], {
          testid: i === 0 ? 'account-employee-card' : undefined,
          key: (0, _concatTokens["default"])(member.classID, member.userID),
          member: member,
          division: _this2.props.divisions[member.divisionID],
          "class": _this2.props.classesData[member.classID],
          sendNotification: function sendNotification() {
            return _this2.props.toggleNotificationModal(member.userID);
          },
          onEditEmployee: function onEditEmployee() {
            return _this2.props.editEmployee(member);
          },
          onManageEmployee: function onManageEmployee() {
            return _this2.props.manageEmployee(member);
          },
          whitelabel: _this2.props.whitelabel,
          onClick: function onClick() {
            window.location.href = _this2.props.isMasterSite ? "/members/".concat(member.userID) : "/employee/".concat(member.accountID, "/").concat(member.userID);
          }
        });
      });
      this.setState({
        memberCards: firstMemberCards
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;
      if (nextProps.employees !== this.state.employeeList) {
        var firstMemberLoad = nextProps.employees.slice(0, 50);
        var firstMemberCards = firstMemberLoad.map(function (member, i) {
          return /*#__PURE__*/_react["default"].createElement(_MemberCard["default"], {
            testid: i === 0 ? 'account-employee-card' : undefined,
            key: (0, _concatTokens["default"])(member.classID, member.userID),
            member: member,
            division: _this3.props.divisions[member.divisionID],
            "class": _this3.props.classesData[member.classID],
            sendNotification: function sendNotification() {
              return _this3.props.toggleNotificationModal(member.userID);
            },
            onEditEmployee: function onEditEmployee() {
              return _this3.props.editEmployee(member);
            },
            onManageEmployee: function onManageEmployee() {
              return _this3.props.manageEmployee(member);
            },
            onClick: function onClick() {
              window.location.href = _this3.props.isMasterSite ? "/members/".concat(member.userID) : "/employee/".concat(member.accountID, "/").concat(member.userID);
            }
          });
        });
        this.setState({
          employeeList: nextProps.employees,
          memberCards: firstMemberCards,
          loadIndex: 50
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(MemberListHeader, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 2,
        sm: 2,
        md: 1
      }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 4,
        sm: 4,
        md: 6
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true
      }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.name))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 1,
        sm: 1,
        md: 1,
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, _i18n["default"].t(_tokens["default"].titles.division))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 2,
        sm: 2,
        md: 2,
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, _i18n["default"].t(_tokens["default"].titles["class"]))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 1,
        sm: 1,
        md: 1,
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, _i18n["default"].t(_tokens["default"].labels.claims.status))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 2,
        sm: 1,
        md: 1,
        style: {
          textAlign: 'center'
        }
      })), this.state.memberCards, this.state.loadIndex < this.state.employeeList.length && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this._loadMore,
        color: "primary",
        customStyle: {
          margin: '20px auto 0',
          display: 'block'
        }
      }, "LOAD MORE"));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = MemberList;